import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Kit de Emergencia Eléctrica 10 Min',
    desc: 'Son las 11 de la noche. Se fue la luz. No sabés qué hacer. Este bono es exactamente para ese momento. Protocolo de 3 escenarios, árbol de decisión, tabla de síntomas y checklist imprimible. Diseñado para usarse con las manos temblando y la linterna del móvil encendida.',
    val: '37€',
    img: 'https://cdn.magicpatterns.com/uploads/cCtnKVneD3x9b2CoPjNVNr/bono_1_webp.webp'
  }, {
    num: 2,
    title: 'Checklist de Herramientas y Materiales',
    desc: 'La lista exacta para ir a la ferretería y salir con lo mínimo que te permite resolver el 80% de los trabajos domésticos. Sin comprar de más. Sin comprar de menos. Con 3 niveles de kit (Mínimo, Recomendado y Avanzado) y guía de calidad incluida.',
    val: '27€',
    img: 'https://cdn.magicpatterns.com/uploads/ppRYxTjdyGmA4ffVwmXzcE/bono_2_webp.webp'
  }, {
    num: 3,
    title: 'Guía Anti-Errores: Los 27 Fallos',
    desc: 'Los 27 errores que hacen que la reparación simple salga carísima. No es la reparación lo que duele. Es el error de 30 segundos que nadie te avisó que ibas a cometer. Esta guía existe para que no seas vos quien lo descubra de la peor manera.',
    val: '33€',
    img: 'https://cdn.magicpatterns.com/uploads/dRPVbWat6cAUfCLqRasC62/bono_3_webp.webp'
  }];
  return <section className="w-full bg-black py-20 px-4 text-white" data-id="element-43">
      <div className="max-w-5xl mx-auto" data-id="element-44">
        <div className="text-center mb-16" data-id="element-45">
          <span className="bg-yellow-500/20 text-yellow-400 border border-yellow-500/50 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-46">
            🎁 Solo por hoy — Completamente gratis
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-white mt-6 leading-tight" data-id="element-47">
            Además de los 4 Tomos Hoy Recibís 3 Bonos Gratis
          </h2>
          <p className="text-xl text-gray-400 mt-4 font-medium" data-id="element-48">
            Estos 3 bonos tienen un valor de mercado de 97€ pero hoy los recibís
            sin coste adicional cuando comprás la colección.
          </p>
        </div>

        <div className="space-y-12 mb-16" data-id="element-49">
          {bonuses.map((b, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gray-900 rounded-2xl p-6 md:p-8 border border-gray-800 flex flex-col md:flex-row gap-8 items-center shadow-2xl" data-id="element-50">
              <div className="w-full md:w-1/3 shrink-0" data-id="element-51">
                <img src={b.img} alt={b.title} className="w-full max-w-[250px] mx-auto rounded-xl shadow-lg" data-id="element-52" />
              </div>
              <div className="w-full md:w-2/3" data-id="element-53">
                <div className="text-yellow-400 font-bold text-sm uppercase tracking-wider mb-2" data-id="element-54">
                  🎁 BONO #{b.num} — GRATIS HOY
                </div>
                <h3 className="text-2xl md:text-3xl font-black text-white mb-4" data-id="element-55">
                  {b.title}
                </h3>
                <p className="text-gray-300 text-lg mb-6 leading-relaxed" data-id="element-56">
                  {b.desc}
                </p>
                <div className="inline-block bg-black/50 border border-gray-700 rounded-lg px-4 py-2" data-id="element-57">
                  <span className="text-gray-400 font-medium" data-id="element-58">
                    💛 Valor real: <span className="line-through" data-id="element-59">{b.val}</span>
                  </span>
                  <span className="text-green-400 font-bold ml-2" data-id="element-60">
                    → HOY GRATIS ✓
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-61">
          <motion.a href="#compra" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-yellow-400 hover:bg-yellow-500 text-black font-black text-lg md:text-2xl py-4 md:py-5 px-8 md:px-12 rounded-lg shadow-[0_5px_0_rgb(202,138,4)] hover:shadow-[0_2px_0_rgb(202,138,4)] hover:translate-y-[3px] transition-all w-full max-w-2xl uppercase tracking-wide" data-id="element-62">
            🎁 QUIERO LOS 4 TOMOS + 3 BONOS GRATIS →
          </motion.a>
        </div>
      </div>
    </section>;
}